














export default {
    data() {
        return {
            model: '',
        };
    },
    props: ['currentFilter'],
    mounted(this: any) {
        if (this.currentFilter && this.currentFilter.value) {
            this.model = this.currentFilter.value;
        }
    },
    methods: {
        change(this: any) {
            this.$emit('change', this.currentFilter, this.model);
        },
        reset(this: any) {
            this.model = '';
        },
    },
};
